import axios from "axios";

export default function EntrylocationDeniedEmployeesDeleteService(formData) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/employee/deniedEmployees",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
